// @flow

import type {
  ExpReviewRatingState,
  ExpReviewRatingStateAction
} from 'stores/flow-type/exp-review-rating.type';

import {
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST,
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS,
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE,
  GET_EXP_REVIEW_RATING_STATUS_REQUEST,
  GET_EXP_REVIEW_RATING_STATUS_SUCCESS,
  GET_EXP_REVIEW_RATING_STATUS_FAILURE,
  RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK
} from 'stores/flow-type/exp-review-rating.type';

const initialState: ExpReviewRatingState = {
  expReviewRatingLoading: false,
  expReviewRatingSuccess: false,
  expReviewRatingStatusLoading: false,
  expReviewRatingStatusSuccess: false,
  allowToShowReview: false,
  allowToShowButton: false,
  step: 'rating',
  rating: 0,
  clicks: 0,
  status: false,
  event: '',
  triggeredAt: 0,
  error: null
};

const supportTicketReducers = (
  state: ExpReviewRatingState = initialState,
  action: ExpReviewRatingStateAction
) => {
  switch (action.type) {
    case EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST:
      return { ...state, expReviewRatingLoading: true };
    case EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS: {
      const { rating } = action.payload;
      return {
        ...state,
        expReviewRatingLoading: false,
        expReviewRatingSuccess: true,
        rating,
        error: undefined
      };
    }
    case EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE:
      return {
        ...state,
        expReviewRatingLoading: false,
        expReviewRatingSuccess: false,
        error: action.payload
      };
    case GET_EXP_REVIEW_RATING_STATUS_REQUEST:
      return { ...state, expReviewRatingStatusLoading: true };
    case GET_EXP_REVIEW_RATING_STATUS_SUCCESS: {
      const { data = {} } = action.payload;
      return {
        ...state,
        ...data,
        expReviewRatingStatusLoading: false,
        expReviewRatingStatusSuccess: true,
        error: undefined
      };
    }
    case GET_EXP_REVIEW_RATING_STATUS_FAILURE:
      return {
        ...state,
        expReviewRatingStatusLoading: false,
        expReviewRatingStatusSuccess: false,
        error: action.payload
      };
    case RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK:
      return {
        ...state,
        expReviewRatingLoading: false,
        expReviewRatingSuccess: false,
        error: undefined
      };
    default:
      return state;
  }
};
export default supportTicketReducers;
